// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-section .mp-section-title-container{padding-left:20px}.mp-section .mp-section-title-container .mp-section-title{color:var(--gray5);font-family:Garnett;font-size:16px;font-weight:500}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
